import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import professionImg from '../assets/profession.png';
import cheapImg from '../assets/cheap.png';
import secureImg from '../assets/secure.png';

type Card = {
  name: string;
  img: string;
  info1: string;
  info2: string;
}

const cardData: Card[] = [
  {
    name: '专业保障',
    img: professionImg,
    info1: '经验丰富的代理师及顾问团队',
    info2: '全程提供专业指导建议，为服务做保障',
  },
  {
    name: '高性价比',
    img: cheapImg,
    info1: '满意价格，高效服务',
    info2: '全程价格透明，无隐形消费',
  },
  {
    name: '低风险',
    img: secureImg,
    info1: '精准的专利检索分析',
    info2: '降低专利申请的驳回风险',
  },
];

const useStyles = makeStyles(() => ({
  advantage: {
    padding: '42px 50px',
    background: '#fff',
    '& h1': {
      fontSize: 42,
      textAlign: 'center'
    },
    '& > div': {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: 56,
      '& > div': {
        flex: 1
      },
      '& > div + div': {
        marginLeft: '20px'
      }
    },
    '@media (max-width: 1260px)': {
      padding: '42px 0px',
      '& > div': {
        padding: 0,
        flexDirection: 'column',
        '& > div + div': {
          marginLeft: '0px !important'
        }
      }
    }
  },
}));

const cardUseStyles = makeStyles(() => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    '& img': {
      width: '100%',
      minWidth: '200px',
    },
    '& h2,h3': {
      color: '#333',
      textAlign: 'center'
    },
    '& h2': {
      height: 86,
      lineHeight: '86px',
      fontSize: 32,
      margin: 0,
      borderBottom: '1px solid #eee'
    },
    '& h3': {
      margin: '10px 0 0 0',
    },
    '@media (max-width: 1260px)': {
      marginTop: 60,
      width: '100%'
    }
  },
}));

const CardComponent: React.FC<{ data: Card }> = ({ data }) => {
  const classes = cardUseStyles();

  return (
    <div className={classes.card}>
      <img src={data.img} alt="" />
      <h2>{data.name}</h2>
      <h3>{data.info1}</h3>
      <h3>{data.info2}</h3>
    </div>
  );
};

const AdvantageComponent: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.advantage}>
      <h1>我们的优势</h1>
      <div>
        { cardData.map((data, index) => <CardComponent key={`card${index}`} data={data} />) }
      </div>
    </div>
  );
}

export default AdvantageComponent;